import React, { PropsWithChildren } from "react";

import { cn } from "@/utils/cn";

export interface IAvatarProps extends PropsWithChildren {
	url?: string | null;
	alt?: string;
	className?: string;
	onClick?: () => void;
	loading?: boolean;
	rounded?: boolean;
	imageFit?: "cover" | "contain" | string;
	imagePosition?: string;
}

export const Avatar: React.FC<IAvatarProps> = ({
	children,
	imageFit = "cover",
	imagePosition = "center",
	rounded = true,
	...props
}) => {
	return (
		<div
			className={cn([
				"relative h-full w-full overflow-hidden shadow-inner",
				rounded && "rounded-full",
				!props.url && "bg-neutral-100",
				props.className,
			])}
			style={{
				backgroundImage: `url('${props.url || ""}')`,
				backgroundSize: imageFit,
				backgroundPosition: imagePosition,
				backgroundRepeat: "no-repeat",
			}}
		>
			{children}
		</div>
	);
};
